export type TNativeGainNode = GainNode;
